import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Ticker from "@/components/site/Ticker";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Heritage from "@/components/site/Heritage";
import Reviews from "@/components/site/Reviews";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain relative text-bone overflow-x-hidden">
      <div className="fixed inset-0 z-0 pointer-events-none">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/88f3cf28-08a6-4c4d-a110-4a623efba473/images/e3677d29f4d6b8fe144296fc0b155d136de647b1e023f3251ae6e66511784c6e.jpeg"
          alt=""
          className="w-full h-full object-cover opacity-45"
        />
        <div className="absolute inset-0 bg-ink/65" />
      </div>
      <div className="relative z-10">
        <Toaster theme="dark" position="top-right" richColors />
        <Navbar />
        <main>
          <Hero />
          <Ticker />
          <About />
          <Services />
          <Gallery />
          <Heritage />
          <Reviews />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;
